import * as React from 'react'
//
import '../../utils/fonts'

import { StyleSheet, Text, View } from '@react-pdf/renderer'

import { styleConfig } from '../config'

interface HeaderProps {
	text?: React.ReactNode
}

export const Body: React.FC<HeaderProps> = ({ text }) => {
	return (
		<View style={styles.body}>
			<Text style={styles.text}>{text}</Text>
		</View>
	)
}

const styles = StyleSheet.create({
	body: {
		maxWidth: '90%',
		marginBottom: '16mm',
	},
	text: {
		fontSize: styleConfig?.fontSize,
	},
})
